import { Controller } from '@hotwired/stimulus';

// Certifique-se de que este controller seja registrado como "education-level-toggle"
export default class extends Controller {
  static targets = ['juvenileBtn', 'infantileBtn', 'toggleButtons'];
  static values = { currentLevel: String };
  static params = ['level'];

  toggleEducationLevel(event) {
    // Obter o valor do parâmetro como string ('true' ou 'false')
    const levelParam = event.params.level;

    // Atualizar a interface de acordo com o botão clicado
    if (levelParam === 'false') {
      // Botão Juvenil clicado
      this.juvenileBtnTarget.setAttribute('data-active', 'true');
      this.infantileBtnTarget.setAttribute('data-active', 'false');
    } else if (levelParam === 'true') {
      // Botão Infantil clicado
      this.juvenileBtnTarget.setAttribute('data-active', 'false');
      this.infantileBtnTarget.setAttribute('data-active', 'true');
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    fetch('/users/update_education_level', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        Accept: 'application/json',
      },
      body: JSON.stringify({ education_level: levelParam }),
      credentials: 'same-origin',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Resposta do servidor não foi OK');
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          if (data.redirect_url) {
            setTimeout(() => {
              window.location.href = data.redirect_url;
            }, 100);
          } else {
            window.location.reload();
          }
        } else if (data.error) {
          console.error('Erro:', data.error);
        }
      })
      .catch((error) => {
        console.error('Erro ao atualizar nível educacional:', error);
        // Em caso de erro, recarregar a página para garantir que a UI esteja consistente
        window.location.reload();
      });
  }
}
